import React from "react";
import Section from "./Section";
import { Link } from "./../util/router";
import "./Footer.scss";

function Footer(props) {
  return (
    <Section
      color={props.color}
      size={props.size}
      backgroundImage={props.backgroundImage}
      backgroundImageOpacity={props.backgroundImageOpacity}
      className="footer"
    >
      <div className="FooterComponent__container container">
        <div className="brand left">
          <Link to="/">
            <img src={props.logo} alt="Logo" />
          </Link>
        </div>
        <div className="links right">
          <Link to="/about">About</Link>
          <Link to="/contact">Contact</Link>
        </div>
        <div className="social right">
          <a
            href="https://github.com/edzlabs"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="icon">
              <i className="fab fa-github is-size-4" />
            </span>
          </a>
          <a
            href="https://discord.com/invite/WDHF5RjR?utm_source=Discord%20Widget&utm_medium=Connect"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="icon">
              <i className="fab fa-discord is-size-4" />
            </span>
          </a>
          <a
            href="https://twitter.com/_pdsofficial?lang=en"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="icon">
              <i className="fab fa-x-twitter is-size-4" />
            </span>
          </a>
          <a
            href="https://www.linkedin.com/company/personal-digital-spaces/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="icon">
              <i className="fab fa-linkedin is-size-4" />
            </span>
          </a>

        </div>
        <div className="copyright left">
          {props.copyright}
        </div>
      </div>
    </Section>
  );
}

export default Footer;
